import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { memberDtoSchema, pagedResultSchema } from '../schemas/memberSchemas';
import { memberKeys } from './memberKeys';

interface ListMembersParams {
  page: number;
  pageSize: number;
  search?: string;
}

export function useListMembers({ page, pageSize, search }: ListMembersParams) {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: memberKeys.list({ page, pageSize, search }),
    queryFn: async ({ signal }) => {
      const searchParams: Record<string, string | number> = { page, pageSize };
      if (search) searchParams.search = search;

      const raw = await apiClient
        .get(`api/v1/t/${tenantId}/members`, { searchParams, signal })
        .json();

      return pagedResultSchema(memberDtoSchema).parse(raw);
    },
    enabled: !!tenantId,
  });
}
